import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import {
  fetchPropertyPayments,
  PropertyPaymentFilters,
} from '@/renderer/services/accommodationService';

export function usePropertyPayments(
  propertyId: string | null | undefined,
  filters?: PropertyPaymentFilters,
) {
  return useQuery({
    queryKey: queryKeys.accommodation.propertyPayments(
      propertyId ?? '',
      filters,
    ),
    queryFn: () => fetchPropertyPayments(propertyId!, filters),
    enabled: !!propertyId,
    placeholderData: keepPreviousData,
  });
}
